import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCreators, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useEngineTypeParameters = () => {
  const dispatch = useDispatch();
  const { changeBevSupportFilter } = bindActionCreators(actionCreators, dispatch);
  const [searchParams] = useSearchParams();

  const bevQuery = searchParams.get("engineType") || searchParams.get("engine_type");

  useEffect(() => {
    if (bevQuery && (bevQuery === "hybrid" || bevQuery === "bev")) {
      changeBevSupportFilter(true);
    }
  }, [bevQuery]);

  const engineTypeQueryParams = (): Record<string, string> => {
    return {
      // add brand if existing
      ...(store.getState().filters.bevSupport && {
        bevSupport: store.getState().filters.bevSupport.toString(),
      }),
    };
  };

  return { engineTypeQueryParams };
};
